/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiQueryTemplate,
    ApiQueryTemplateFromJSON,
    ApiQueryTemplateToJSON,
    ApiQueryTemplateUpdate,
    ApiQueryTemplateUpdateFromJSON,
    ApiQueryTemplateUpdateToJSON,
    ApiQueryTemplateUpdateRequest,
    ApiQueryTemplateUpdateRequestFromJSON,
    ApiQueryTemplateUpdateRequestToJSON,
    QueryTemplatePage,
    QueryTemplatePageFromJSON,
    QueryTemplatePageToJSON,
} from '../models';

export interface CreateQueryTemplateRequest {
    apiQueryTemplateUpdateRequest: ApiQueryTemplateUpdateRequest;
}

export interface DeleteQueryTemplateRequest {
    id: number;
}

export interface FindQueryTemplatesRequest {
    page: number;
    size: number;
    query?: string;
}

export interface GetQueryTemplateUpdateRequest {
    handle: string;
}

export interface UpdateQueryTemplateRequest {
    id: number;
    apiQueryTemplateUpdateRequest: ApiQueryTemplateUpdateRequest;
}

/**
 * 
 */
export class QueryTemplateApi extends runtime.BaseAPI {

    /**
     * Creates query template
     */
    async createQueryTemplateRaw(requestParameters: CreateQueryTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiQueryTemplate>> {
        if (requestParameters.apiQueryTemplateUpdateRequest === null || requestParameters.apiQueryTemplateUpdateRequest === undefined) {
            throw new runtime.RequiredError('apiQueryTemplateUpdateRequest','Required parameter requestParameters.apiQueryTemplateUpdateRequest was null or undefined when calling createQueryTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/querytemplates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiQueryTemplateUpdateRequestToJSON(requestParameters.apiQueryTemplateUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiQueryTemplateFromJSON(jsonValue));
    }

    /**
     * Creates query template
     */
    async createQueryTemplate(requestParameters: CreateQueryTemplateRequest, initOverrides?: RequestInit): Promise<ApiQueryTemplate> {
        const response = await this.createQueryTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes query template
     */
    async deleteQueryTemplateRaw(requestParameters: DeleteQueryTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiQueryTemplate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteQueryTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/querytemplates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiQueryTemplateFromJSON(jsonValue));
    }

    /**
     * Deletes query template
     */
    async deleteQueryTemplate(requestParameters: DeleteQueryTemplateRequest, initOverrides?: RequestInit): Promise<ApiQueryTemplate> {
        const response = await this.deleteQueryTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all query template names for organisation
     */
    async findAllQueryTemplateNamesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/querytemplates/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Fetches all query template names for organisation
     */
    async findAllQueryTemplateNames(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.findAllQueryTemplateNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches query templates for organisation
     */
    async findQueryTemplatesRaw(requestParameters: FindQueryTemplatesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<QueryTemplatePage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findQueryTemplates.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findQueryTemplates.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/querytemplates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueryTemplatePageFromJSON(jsonValue));
    }

    /**
     * Fetches query templates for organisation
     */
    async findQueryTemplates(requestParameters: FindQueryTemplatesRequest, initOverrides?: RequestInit): Promise<QueryTemplatePage> {
        const response = await this.findQueryTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches query template update
     */
    async getQueryTemplateUpdateRaw(requestParameters: GetQueryTemplateUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiQueryTemplateUpdate>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling getQueryTemplateUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/querytemplates/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiQueryTemplateUpdateFromJSON(jsonValue));
    }

    /**
     * Fetches query template update
     */
    async getQueryTemplateUpdate(requestParameters: GetQueryTemplateUpdateRequest, initOverrides?: RequestInit): Promise<ApiQueryTemplateUpdate> {
        const response = await this.getQueryTemplateUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates query template
     */
    async updateQueryTemplateRaw(requestParameters: UpdateQueryTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiQueryTemplate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateQueryTemplate.');
        }

        if (requestParameters.apiQueryTemplateUpdateRequest === null || requestParameters.apiQueryTemplateUpdateRequest === undefined) {
            throw new runtime.RequiredError('apiQueryTemplateUpdateRequest','Required parameter requestParameters.apiQueryTemplateUpdateRequest was null or undefined when calling updateQueryTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/querytemplates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiQueryTemplateUpdateRequestToJSON(requestParameters.apiQueryTemplateUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiQueryTemplateFromJSON(jsonValue));
    }

    /**
     * Updates query template
     */
    async updateQueryTemplate(requestParameters: UpdateQueryTemplateRequest, initOverrides?: RequestInit): Promise<ApiQueryTemplate> {
        const response = await this.updateQueryTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
